<template>
    <div class="installment-options">
        <div></div>
        <button @click="()=>    {toggleInstallment(); changeOne()}" :class="{ active : one}">
            <span>10 </span> rat<p class="info">możliwość odroczenia</p>
            <div :class="{ line : one }"></div>
            <div :class="{ triangle : one }"></div>
        </button>
        <button @click="()=>{toggleInstallment(); changeTwo()}" :class="{ active : two}">
            <span>20 </span> rat
            <div :class="{ line : two }"></div>
            <div :class="{ triangle : two}"></div>
        </button>
        <button @click="()=>{toggleInstallment(); changeThree()}" :class="{ active : three}">
            <span>30 </span> rat
            <div :class="{ line : three }"></div>
            <div :class="{ triangle : three }"></div>
        </button>
        <div></div>
    </div>
</template>
<script>
export default {
    data(){
        return{
           one:true,
           two:false,
           three:false
        }
    },
    methods:{
        toggleInstallment:function(){
            this.one = false
            this.two = false 
            this.three = false
        },
        changeOne: function(){ this.one = true, this.$bus.$emit('changeOne',10) },
        changeTwo: function(){ this.two = true, this.$bus.$emit('changeTwo',20) },
        changeThree: function(){ this.three = true, this.$bus.$emit('changeThree',30) }
    }
    
}
</script>



// WEBPACK FOOTER //
// src/components/Blocks/Installment.vue